import React from 'react';
import { FaGraduationCap, FaChalkboardTeacher, FaAward, FaLaptop } from 'react-icons/fa';

const Features = () => {
  const features = [
    {
      icon: <FaGraduationCap />,
      title: 'Quality Education',
      description: 'Comprehensive curriculum designed to meet industry standards and academic excellence.'
    },
    {
      icon: <FaChalkboardTeacher />,
      title: 'Expert Faculty',
      description: 'Learn from experienced professors and industry professionals dedicated to your success.'
    },
    {
      icon: <FaAward />,
      title: 'Recognized Programs',
      description: 'Accredited programs that are valued by employers and institutions worldwide.'
    },
    {
      icon: <FaLaptop />,
      title: 'Smart Classrooms',
      description: 'State-of-the-art facilities equipped with the latest technology for enhanced learning.'
    }
  ];

  return (
    <section className="features">
      <div className="container">
        <h2 className="section-title">Why Choose Fast Track College of Business, Healthcare and Technology?</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
